import type { SVGProps } from 'react';

const SvgNoticeOnMd1 = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.1129 7.78974V18.3563C7.1129 19.2641 7.92168 20 8.91935 20C9.91703 20 10.7258 19.2641 10.7258 18.3563V15.8293M6.3399 14.214L15.6609 18.0151C17.0181 18.515 18.5 17.6061 18.5 16.2739V5.88038C18.5 4.54812 17.0181 3.63926 15.6609 4.13911L6.3399 7.94025C4.93536 8.45754 3.5 9.16588 3.5 11.203C3.5 12.9229 4.93536 13.6967 6.3399 14.214Z'
      stroke='currentColor'
      strokeWidth={1.5}
    />
    <circle cx={22} cy={2} r={2} fill='#FF5A5A' />
  </svg>
);
export default SvgNoticeOnMd1;
